<template>
  <div class="section section-game" id="game-section" data-background-color="black">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="text-center col-md-12 col-lg-12">
          <h3 data-aos="fade-up" data-aos-offset="-100" class="title deco2">{{$t(`About Game`)}}</h3>
          <div class="space-50"></div>
          <div class="row" style="padding-bottom: 60px;">
            <div data-aos="fade-right" data-aos-offset="-100" class="col-md-6" style="padding: 0;">
              <img v-lazy="'/img/img_game_01.png'" width="100%" height="100%" />
            </div>
            <div data-aos="fade-left" data-aos-offset="-100" class="col-md-6" style="background-image: url('/img/bg_game_01.png'); min-height: 220px; background-size: cover; background-repeat: no-repeat;">
              <img class="img_deco_05" src="/img/img_deco_04.png" />
              <h5 class="description-game-title text-left" style="padding-left: 20px; padding-top:50px;"><img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px;" /> {{$t(`game title 1`)}}</h5>
              <h5 class="description-game-desc text-left" style="padding-left: 20px;">{{$t(`game desc 1`)}}</h5>
            </div>
          </div>
          <div class="row" style="padding-bottom: 60px;">
            <div data-aos="fade-right" data-aos-offset="-200" class="col-md-6" style="padding: 0;">
              <img v-lazy="'/img/img_game_02.png'" width="100%" height="100%" />
            </div>
            <div data-aos="fade-left" data-aos-offset="-200" class="col-md-6" style="background-image: url('/img/bg_game_01.png'); min-height: 220px; background-size: cover; background-repeat: no-repeat;">
              <img class="img_deco_05" src="/img/img_deco_05.png" />
              <h5 class="description-game-title text-left" style="padding-left: 20px; padding-top:50px;"><img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px;" /> {{$t(`game title 2`)}}</h5>
              <h5 class="description-game-desc text-left" style="padding-left: 20px;">{{$t(`game desc 2`)}}</h5>
            </div>
          </div>
          <div class="row" style="padding-bottom: 60px;">
            <div data-aos="fade-right" data-aos-offset="-300" class="col-md-6" style="padding: 0;">
              <img v-lazy="'/img/img_game_03.png'" width="100%" height="100%" />
            </div>
            <div data-aos="fade-left" data-aos-offset="-300" class="col-md-6" style="background-image: url('/img/bg_game_01.png'); min-height: 220px; background-size: cover; background-repeat: no-repeat;">
              <img class="img_deco_05" src="/img/img_deco_06.png" />
              <h5 class="description-game-title text-left" style="padding-left: 20px; padding-top:50px;"><img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px;" /> {{$t(`game title 3`)}}</h5>
              <h5 class="description-game-desc text-left" style="padding-left: 20px;">{{$t(`game desc 3`)}}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
